// extracted by mini-css-extract-plugin
module.exports = {"Difficulty":"Difficulty_Difficulty__783Zd","Skip":"Difficulty_Skip__Vhgz-","DiffButton":"Difficulty_DiffButton__15tC8"};